'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _connectField = require('uniforms/connectField');

var _connectField2 = _interopRequireDefault(_connectField);

var _wrapField = require('./wrapField');

var _wrapField2 = _interopRequireDefault(_wrapField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bool = function Bool(_ref) {
    var label = _ref.label,
        labelBefore = _ref.labelBefore,
        props = (0, _objectWithoutProperties3.default)(_ref, ['label', 'labelBefore']);
    return (0, _wrapField2.default)((0, _extends3.default)({ label: labelBefore }, props), _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)(props.inputClassName, 'form-check', 'checkbox' + (props.inline ? '-inline' : '') // bootstrap4 < alpha.6
            )
        },
        _react2.default.createElement(
            'label',
            { htmlFor: props.id, className: 'form-check-label' },
            _react2.default.createElement('input', {
                checked: props.value,
                className: 'form-check-input',
                disabled: props.disabled,
                id: props.id,
                name: props.name,
                onChange: function onChange() {
                    return props.onChange(!props.value);
                },
                ref: props.inputRef,
                type: 'checkbox'
            }),
            '\xA0',
            label
        )
    ));
};

exports.default = (0, _connectField2.default)(Bool);


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-bootstrap4/BoolField.js
// module id = 191
// module chunks = 0